<div class="modal-content">
  <h3 class="text-[24px] leading-[32px] text-center">Single Founder</h3>

  <ol class="mt-[10px]">
    <li>
      Founder can select other Co-Founders for the Solution.
      <ol type="a">
        <li>Founder and Co-Founder names are listed in the Solution.</li>
        <li>Co-Founders are granted a percentage of voting rights as determined by the Founder.</li>
      </ol>
    </li>

    <li>
      Founder must select the Governing Board within 3 months of the Solution attracting 25,000 backers.
      <ol type="a">
        <li>The Board will consist of 3 or more Members (must be an odd number).</li>
        <li>The Founder has the right to be on the Board.</li>
        <li>Board Members can be removed and replaced by the Founder.</li>
      </ol>
    </li>

    <li>
      Self-perpetuating Board.
      <ol type="a">
        <li>The Board replaces an inactive Member if the Founder doesn’t do so within 4 weeks.</li>
        <li>Co-Founders select the Board, if the Founder fails to do so.</li>
        <li>Backers choose the Board if the Founder/Co-Founders fail to do so.</li>
      </ol>
    </li>

    <li>
      Decision Making.
      <ol type="a">
        <li>In the beginning, the Founder makes all decisions.</li>
        <li>
          Once the Board is seated, it makes all decisions — with input from the Founder and Backers —
          regarding authoring, editing, and promoting the Solution.
        </li>
      </ol>
    </li>

    <li>
      All Brands/IP from the Solution are owned and controlled by the Founders.
      <ol type="a">
        <li>Founders can divide up ownership as they wish.</li>
      </ol>
    </li>
  </ol>
</div>
